import createIsValid from './selectors/isValid';
import plain from './structure/plain';

export default createIsValid(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/isValid.js
// module id = 503
// module chunks = 0